import PropTypes from "prop-types";
import { useRef, useState } from "react";

import styled from "styled-components/macro";

import { formatDateString } from "CrossFeatureComponents/UserRecurringGifts/Shared/formatDateString";

import { FnrPopover } from "UI/FnrPopover2";
import FnrTooltip from "UI/FnrTooltip2";

import PopoverContent from "./PopoverContent";
import TooltipContent from "./TooltipContent";

StatusNotificationIcon.propTypes = {
  status: PropTypes.string,
  failedPaymentsCount: PropTypes.number,
  lastConsecutiveFailedPayments: PropTypes.array,
  paymentType: PropTypes.string,
  paymentDates: PropTypes.array,
  ID: PropTypes.number,
};

export default function StatusNotificationIcon({
  status,
  failedPaymentsCount,
  lastConsecutiveFailedPayments,
  paymentType,
  paymentDates,
  ID,
}) {
  const [showPopover, setShowPopover] = useState(false);

  const statusIconButtonRef = useRef();

  const handleClose = () => {
    setShowPopover(false);
  };

  const nextPaymentDate = formatDateString(paymentDates[0] || null);

  if (
    status === "expired" ||
    (status === "active" && failedPaymentsCount !== 1)
  )
    return null;

  return (
    <>
      <FnrTooltip
        content={
          <TooltipContent
            status={status}
            failedPaymentsCount={failedPaymentsCount}
            paymentType={paymentType}
          />
        }
        hide={showPopover}
      >
        <StatusIconButton
          ref={statusIconButtonRef}
          className={
            status === "paused"
              ? "fas fa-pause-circle"
              : "fad fa-exclamation-triangle"
          }
          isPaused={status === "paused"}
          onClick={() => setShowPopover((prev) => !prev)}
        />
      </FnrTooltip>
      <FnrPopover
        buttonRef={statusIconButtonRef}
        show={showPopover}
        onShouldClose={handleClose}
      >
        <PopoverContent
          status={status}
          paymentType={paymentType}
          nextPaymentDate={nextPaymentDate}
          ID={ID}
          failedPaymentsCount={failedPaymentsCount}
          lastConsecutiveFailedPayments={lastConsecutiveFailedPayments}
          handleClose={handleClose}
        />
      </FnrPopover>
    </>
  );
}

const StatusIconButton = styled.div`
  cursor: pointer;
  --fa-secondary-color: #faaf00;
  font-size: 21px;
  opacity: ${({ isPaused }) => (isPaused ? 0.9 : 1)};

  transition: all 250ms;

  &:hover {
    transform: scale(1.1);
    --fa-secondary-color: #c78b00;
  }

  &:active {
    transform: scale(0.9);
  }
`;
